// src/lib/kiwiAffiliate.ts
// LOT ÉVASION KIWI SYNC — Source unique frontend pour les liens affiliés Kiwi/Travelpayouts.

export const FORFEO_AFFILIATE_TRS = '501285';
export const FORFEO_AFFILIATE_SHMARKER = '705546';

export type KiwiFlightLinkInput = {
  origin?: string | null;
  destination?: string | null;
  travelPeriod?: string | null;
  passengers?: string | number | null;
  directOnly?: boolean | null;
  currency?: string | null;
  locale?: string | null;
  source?: string | null;
  campaignId?: string | number | null;
  promoId?: string | number | null;
};

export const normalizeAirportCode = (value?: string | null, fallback = '') => {
  const raw = String(value || '').trim();
  const upper = raw.toUpperCase();
  if (/^[A-Z]{3}$/.test(upper)) return upper;

  const normalized = raw
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const airports: Record<string, string> = {
    quebec: 'YQB',
    'quebec city': 'YQB',
    montreal: 'YUL',
    montréal: 'YUL',
    yul: 'YUL',
    toronto: 'YYZ',
    ottawa: 'YOW',
    vancouver: 'YVR',
    paris: 'CDG',
    nice: 'NCE',
    marseille: 'MRS',
    miami: 'MIA',
    orlando: 'MCO',
    'new york': 'NYC',
    londres: 'LON',
    london: 'LON',
    cancun: 'CUN',
    'cancún': 'CUN',
    lisbonne: 'LIS',
    lisbon: 'LIS',
    porto: 'OPO',
    rome: 'FCO',
    barcelone: 'BCN',
    barcelona: 'BCN',
    madrid: 'MAD',
    tokyo: 'NRT',
    dubai: 'DXB',
    dubaï: 'DXB',
  };

  return airports[normalized] || fallback;
};

export function buildKiwiFlightWidgetUrl(input: KiwiFlightLinkInput = {}) {
  const origin = normalizeAirportCode(input.origin, 'YUL');

  const params = new URLSearchParams({
    currency: 'cad',
    trs: FORFEO_AFFILIATE_TRS,
    shmarker: FORFEO_AFFILIATE_SHMARKER,
    powered_by: 'true',
    locale: 'fr',
    from_name: origin || 'YUL',
    show_header: 'true',
    limit: '3',
    primary_color: '00AE98',
    results_background_color: 'FFFFFF',
    form_background_color: 'FFFFFF',
    campaign_id: '111',
    promo_id: '4478',
  });

  return `https://tpwdg.com/content?${params.toString()}`;
}

export function buildKiwiFlightSearchUrl(input: KiwiFlightLinkInput = {}) {
  const origin = normalizeAirportCode(input.origin, 'YUL');
  const destination = normalizeAirportCode(input.destination, '');
  const params = new URLSearchParams({
    trs: FORFEO_AFFILIATE_TRS,
    shmarker: FORFEO_AFFILIATE_SHMARKER,
    locale: String(input.locale || 'fr'),
    currency: String(input.currency || 'cad').toLowerCase(),
    source: String(input.source || 'forfeo_evasion_alert'),
  });

  if (origin) params.set('origin', origin);
  if (destination) params.set('destination', destination);
  if (input.passengers) params.set('adults', String(input.passengers).replace(/[^0-9]/g, '') || '1');
  if (input.directOnly) params.set('stops', '0');
  if (input.travelPeriod) params.set('campaign', String(input.travelPeriod));

  return `https://www.kiwi.com/deep?${params.toString()}`;
}
